export default "https://cdn-static.gokick.com/assets/fe83fbcc8f1f3696644045565519fd390c3f6ffc/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";